export const state = () => ({
  listings: [],
  currentListing: null,
  inProgressListing: [],
  currentBuyerGroup: null,
  landregSuggestions: null
})

export const mutations = {
  setListings(state, payload) {
    state.listings = payload
  },
  setInProgressListing(state, payload) {
    state.inProgressListing = payload
  },
  // mutations for current listing
  setCurrentListing(state, payload) {
    state.currentListing = payload
  },
  setFastanumer(state, fastanumer) {
    state.currentListing.fastanumer = fastanumer
  },
  setSellerDescription(state, description) {
    state.currentListing.seller_description = description
  },
  setRealestateExistingBuyer(state, existingBuyer) {
    state.currentListing.existing_buyer_group = existingBuyer
  },
  // mutations for buyer group
  setCurrentBuyerGroup(state, buyerGroup) {
    state.currentBuyerGroup = buyerGroup
  },
  setLandregSuggestion(state, suggestion) {
    state.landregSuggestions = suggestion
  }
}

export const actions = {
  fetchLandregSuggestions({ commit }, address) {
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/utilities/address-suggestions/${address}/`)
        .then((res) => {
          commit('setLandregSuggestion', res.data)
          resolve(res.data)
        })
        .catch((error) => {
          reject(error.response)
        })
    })
  },
  fetchAddressSuggestions(context, address) {
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/utilities/address-suggestions/${address}/`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          // handle error
          reject(error)
        })
    })
  },
  async fetchListings(context) {
    const response = await this.$axios.get('realestate/')

    context.commit('setListings', response.data)
  },
  async fetchInProgressListings(context) {
    const response = await this.$axios.get(`realestate/`)

    context.commit('setInProgressListing', response.data)
  },
  // current listing
  setCurrentListingIfNeeded(context, id) {
    const currentListing = context.state.currentListing
    if (!currentListing || currentListing.id !== parseInt(id)) {
      console.log('current listing not correct, fetching')
      return context.dispatch('fetchListingDetails', id)
    } else {
      console.log('did not need to update current listing')
    }
  },
  async fetchListingDetails(context, id) {
    const response = await this.$axios.get(`realestate/${id}/`)

    context.commit('setCurrentListing', response.data)
  },
  async fetchListingBuyerGroup(context, id) {
    const response = await this.$axios.get(`realestate/${id}/buyer-group`)

    if (length(response.data) > 0) {
      context.commit('setRealestateExistingBuyer', response.data)
    } else {
      console.log('no buyer group for listing')
    }
  },
  async retrieveFromRealEstateRegistry(context) {
    const id = context.state.currentListing.id
    await this.$axios.get(
      `realestate/${id}/retrieve-from-real-estate-registry/`
    )
  },
  async getSalesOverviewBase64(context, id) {
    const response = await this.$axios.get(
      `realestate/${id}/salesoverviewbase64/`
    )
    return response.data
  },

  // current buyer group
  setCurrentBuyerGroupIfNeeded(context, id) {
    const currentBuyerGroup = context.state.currentBuyerGroup
    if (!currentBuyerGroup || currentBuyerGroup.id !== parseInt(id)) {
      console.log('current buyer group not correct, fetching')
      return context.dispatch('fetchBuyerGroupDetails', id)
    } else {
      console.log('did not need to update current buyer group')
    }
  },
  async fetchBuyerGroupDetails(context, id) {
    const response = await this.$axios.get(`buyergroup/${id}/`)
    context.commit('setCurrentBuyerGroup', response.data)

    await context.dispatch('setCurrentListingIfNeeded', response.data.listing)
  },
  async initiateSalesOverviewSigning(context, id) {
    const response = await this.$axios.post(
      `buyergroup/${id}/sign-salesoverview/`
    )
    return response.data
  },
  // api calls that don't change state
  async createListing(context, payload) {
    const response = await this.$axios.post('realestate/', payload)
    return response.data
  },
  updateListing(context, { id, payload }) {
    return this.$axios.patch(`realestate/${id}/`, payload)
  },
  async createBuyerGroup(context, id) {
    const response = await this.$axios.post(`realestate/${id}/buyer-group/`, {})
    return response.data
  },
  async createBuyer(context, { buyergroupid, legalIdentifier, email, name }) {
    const response = await this.$axios.post(
      `buyergroup/${buyergroupid}/buyer/`,
      {
        name,
        legal_identifier: legalIdentifier,
        email
      }
    )
    return response.data
  },
  async removeBuyer(context, { buyergroupid, buyerid }) {
    const response = await this.$axios.delete(
      `buyergroup/${buyergroupid}/buyer/${buyerid}/`
    )
    return response.data
  },
  async updateBuyer(context, { buyergroupid, buyerid, payload }) {
    const response = await this.$axios.patch(
      `buyergroup/${buyergroupid}/buyer/${buyerid}/`,
      payload
    )
    return response.data
  }
}

export const getters = {
  /* stepValid: (state, getters) => (stepName, route = stepName) => {
    const validators = {
      'realestate-buyer-id-steps-parties': getters.partiesStepValid,
      'realestate-buyer-id-steps-overview': getters.overviewStepValid,
      'realestate-buyer-id-steps-offer': getters.offerStepValid,
      'realestate-buyer-id-steps-signOffer': getters.signOfferStepValid,
    }
    return validators[stepName](stepName, route)
  }, */
  buyer_partiesStepValid(state) {
    const buyerIsValid = (buyer) => {
      return buyer.email.length > 0 && buyer.name.length > 0
    }
    return (
      state.currentBuyerGroup != null &&
      state.currentBuyerGroup.buyers.length > 0 &&
      state.currentBuyerGroup.buyers.every(buyerIsValid)
    )
  },
  buyer_overviewStepValid(state) {
    return true
  },
  buyer_offerStepValid(state) {
    return false
  },
  buyer_signOfferStepValid(state) {
    return false
  }
}
